module.exports = __webpack_public_path__ + "img/no-team-activity-hours.007dddec.webp";